
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onBeforeUnmount,
  watch,
  computed
} from 'vue'
import { basketService, basketStore, eventEmitter, eventTracker } from 'partners-widget-core'
// @ts-ignore
import { ButtonControl, Counter } from '@book24/ui-components/next'

export default defineComponent({
  name: 'BaseButton',
  components: {
    ButtonControl,
    Counter,
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      required: true,
    },
    cartRoute: {
      type: String,
      required: true,
    },
    checkoutRoute: {
      type: String,
      required: true,
    },
    basketButtonTitle: {
      type: String,
      required: true,
    },
    orderButtonTitle: {
      type: String,
      required: true,
    },
    withCounter: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    const state: Record<any, any> = reactive({
      isLoading: true,
      currentQuantity: 0,
      isRequestProcessing: false,
      isBasketCreating: false,
      coupon: null,
      count: 1,
    })

    const buttonClasses = computed(() => ({
      'b24-btn-wrap--added': state.currentQuantity > 0,
    }))

    const handleAddToBasket = async (): Promise<void> => {
      try {
        if (state.isRequestProcessing) {
          return
        }

        if (state.isBasketCreating) {
          const unwatch = watch(() => state.isBasketCreating,
            (value) => {
              if (!value) {
                handleAddToBasket()
                unwatch()
              }
            })
          return
        }

        state.isLoading = true
        state.isRequestProcessing = true
        if (state.currentQuantity > 0) {
          window.location.href = props.cartRoute
        } else {
          await basketService.addToBasket({
            productId: props.productId,
            quantity: 1,
            asPreOrder: false,
            asGift: false,
          })
          eventTracker.dispatchEvent('add-to-basket', {
            productId: props.productId,
            basket: basketStore.store
          })
        }
      } catch (err) {
        state.isLoading = false
      } finally {
        state.isRequestProcessing = false
      }
    }

    const handlePreorder = (): void => {
      state.isLoading = true
      eventTracker.dispatchEvent('add-to-basket', props.productId)
      let url = `${props.checkoutRoute}?po=1&quantity=${state.count || 1}&productId=${props.productId}`

      if (state.coupon) {
        url += `&coupon=${state.coupon}`
      }

      window.location.href = url
    }

    const onStoreChange = (store: typeof basketStore.store): void => {
      const currentProducts = store.syncProducts.filter((item) => item === props.productId)
      state.isBasketCreating = store.isBasketCreating

      if (currentProducts?.length) {
        state.currentQuantity = currentProducts.length
        state.isLoading = false
      } else {
        state.currentQuantity = 0
      }

      state.coupon = store.promocode
    }

    onMounted(() => {
      eventEmitter.on('basket-store-changed', onStoreChange)
      onStoreChange(basketStore.store)
      state.isLoading = false
    })

    onBeforeUnmount(() => {
      eventEmitter.off('basket-store-changed', onStoreChange)
    })

    return {
      ...toRefs(state),
      buttonClasses,
      handleAddToBasket,
      handlePreorder,
    }
  },

})
